















module.exports =
  name: 'date_changer'
  props: ['mode']
  components: `{
    range_changer: () => import(/* webpackChunkName: "range_changer" */'components/inside/pages/reports/period_range_changer.vue')
  }`
  data: ->
    pickerType: 'month'
  computed:
    back_to_current_month: -> @$t('back_to', [hm_date.format(new Date, 'MMMM')])
    pickerOptions: ->
      shortcuts: @createShortcuts()
      firstDayOfWeek: @$store.getters.first_day_of_week
    not_current_month: -> hm_date.format(@local_month) != hm_date.constants.start_of_current_month
    local_dates:
      get: ->
        dates = @$store.state.ui.transactions.list.dates
        return [hm_date.parse(dates.start), hm_date.parse(dates.end)]
      set: (val) ->
        start = hm_date.format val[0]
        end   = hm_date.format val[1]
        @$router.push { name: @routeName('list'), query: { dates: "#{start}--#{end}" }}
    local_month:
      get: -> hm_date.parse(@$store.state.ui.transactions.calendar.current_month)
      set: (val) ->
        @$router.push { name: @routeName('calendar'), query: { month: hm_date.format(val) }}
    prevMonth: -> hm_date.addMonths(@local_month, -1)
    nextMonth: -> hm_date.addMonths(@local_month, 1)
  mounted: ->
    event = "keyup.calendar_navigation"
    $(window).off(event).on event, (e) =>
      if e.altKey == true
        return if $('textarea:focus').length > 0
        return if $('input:focus').length > 0
        $('[role=prev_month]')[0].click()     if e.keyCode == 37 # left arrow
        $('[role=next_month]')[0].click()     if e.keyCode == 39 # right arrow
        $('[role=current_month]')[0]?.click() if e.keyCode == 38 # up arrow
  methods:
    routeName: (name) -> "#{if HM.is_mobile then 'mobile_' else ''}#{name}"
    selectRange: (range) -> @local_dates = [range.start, range.end]
    goToCurrentMonth: ->
      @$router.push { name: @routeName('calendar'), query: { month: hm_date.constants.start_of_current_month }}
    createShortcuts: (mode) ->
      shortcutsBuilder = require('components/inside/pages/reports/ranges_builder.coffee').list(@$store.getters.first_transaction_date)
      shortcuts = [
        { text: new Date, month: new Date } # this month
        { text: hm_date.addMonths(new Date, -1), month: hm_date.addMonths(new Date, -1) } # last month
        { text: hm_date.addMonths(new Date, -2), month: hm_date.addMonths(new Date, -2) } # last-last month
        { text: hm_date.addMonths(new Date, -3), month: hm_date.addMonths(new Date, -3) } # last-last month
        { text: '' }
      ]
      shortcuts.push shortcutsBuilder
      shortcuts.push [
        { text: '' }
        { text: new Date, range: [hm_date.startOfYear(new Date), hm_date.endOfYear(new Date)] }
        { text: hm_date.addMonths(new Date, -12 * 1), range: [hm_date.startOfYear(hm_date.addMonths(new Date, -12 * 1)), hm_date.endOfYear(hm_date.addMonths(new Date, -12 * 1))] }
        { text: hm_date.addMonths(new Date, -12 * 2), range: [hm_date.startOfYear(hm_date.addMonths(new Date, -12 * 2)), hm_date.endOfYear(hm_date.addMonths(new Date, -12 * 2))] }
        { text: hm_date.addMonths(new Date, -12 * 3), range: [hm_date.startOfYear(hm_date.addMonths(new Date, -12 * 3)), hm_date.endOfYear(hm_date.addMonths(new Date, -12 * 3))] }
      ]
      _.map _.flatten(shortcuts), (sh) =>
        if sh.month
          sh.text = hm_date.format(sh.text, 'MMMM') if hm_date.isValid(hm_date.parse sh.text)
        else
          sh.text = hm_date.format(sh.text, 'YYYY') if hm_date.isValid(hm_date.parse sh.text)
        {
          text: sh.text
          onClick: (picker) =>
            if sh.month
              if @mode == 'calendar'
                picker.$emit 'pick', hm_date.format(sh.month)
              else
                start = hm_date.startOfMonth_f(sh.month)
                end   = hm_date.endOfMonth_f(sh.month)
                picker.$emit 'pick', [start, end]
            if sh.range
              start = hm_date.format sh.range[0]
              end   = hm_date.format sh.range[1]
              picker.$emit 'pick', [start, end]
        }
